export default __webpack_public_path__ + "static/media/Path 93.1cb759c5.svg";